// src/lib/units.js
//
// Feet and meters, one definition (design §7.1). The international foot is
// 0.3048 m exactly, the factor 151's pad_plan_feature_geom() and its zone
// buffer use, so a preview computed here and the geometry the server stores
// agree to the last digit the conversion can affect.
//
// Older modules carry their own copy of the constant (routeFormat.js,
// planMapData.js, padVolumetrics.js); new code imports it from here.

export const M_PER_FT = 0.3048;

export const ftToM = (ft) => ft * M_PER_FT;
export const mToFt = (m) => m / M_PER_FT;
